import './Admin.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { faLock } from '@fortawesome/free-solid-svg-icons'
import { useState } from 'react'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { useNavigate } from 'react-router-dom'


function Admin() {
    const [inputs, setInputs] = useState({})
    const MySwal = withReactContent(Swal)
    const navigate = useNavigate()

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs(values => ({ ...values, [name]: value }))
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const jsonData = {
            email: inputs.email,
            password: inputs.password,
        }

        async function postJSON(jsonData) {
            try {
                const response = await fetch("https://test-api-liard.vercel.app/api/login", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(jsonData),
                });

                const result = await response.json();
                if (result.status === 'ok') {
                    MySwal.fire({
                        html: <i>{result.message}</i>,
                        icon: 'success'
                    }).then((value) => {
                        localStorage.setItem('token', result.token)
                        navigate('/login')
                    })
                } else {
                    MySwal.fire({
                        html: <i>{result.message}</i>,
                        icon: 'error'
                    })
                }
            } catch (error) {
                console.error("Error:", error);
                MySwal.fire({
                    html: <i>Something went wrong. Please try again later.</i>,
                    icon: 'error'
                });
            }
        }

        postJSON(jsonData);

    }

    return (
        <form onSubmit={handleSubmit} className='admin-container'>
            <div className='admin-page'>
                <h>Admin Login</h>
                <div className='input-text'>
                    <div className='email'>
                        <FontAwesomeIcon icon={faUser} />
                        <input type='text'
                            placeholder='email'
                            name='email'
                            value={inputs.email || ""}
                            onChange={handleChange}
                        />
                    </div>
                    <div className='password'>
                        <FontAwesomeIcon icon={faLock} />
                        <input type='password'
                            placeholder='password'
                            name='password'
                            value={inputs.password || ""}
                            onChange={handleChange}
                        />
                    </div>
                </div>
                <button>Login</button>
            </div>
        </form>
    );
}

export default Admin